import { Button, Grid, Tooltip } from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import DuracionSemanas from "../../Duracion/DuracionSemanas";
import DuracionSesiones from "../../Duracion/DuracionSesiones";
import Caracterizacion from "../Fields/Caracterizacion";
import CondicionesContexto from "../Fields/CondicionesContexto";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router";
import { useAuthContext } from "../../../hooks/Auth";
import { useJobContext } from "../../../hooks/Jobs";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";
import HeaderApps from "../../UmmIACategories/Layout/HeaderApps";
import UnidadTematicaCardImg from "../../UmmIApps/Cards/ClaseActivaCardImg.png";
import AdaptacionesCurriculares from "../Fields/AdaptacionesCurriculares";
import NotEnoughCredits from "../../UmmIApps/NotEnoughCredits";
import CurriculumTabs from "../../CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../../config/sendButtonRules";

const UnidadActivaForm = () => {
  const { proyecto, enviarPropuestaInicialUsuario } = useProyecto();
  const { user } = useAuthContext();
  const { setIsNotEnoughOpen, selectedApp } = useActividadesContext();
  const { etapa, tipoEstructura, userId } = useJobContext();

   //Condicionamiento para botón
    const isButtonDisabled = isSendButtonDisabled("unidad_tematica", { proyecto });

  const {
    nivelId,
    materiaId,
    promptData,
    setPromptData,
    mostrarCamposAvanzados,
    toggleCamposAvanzados,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    nivelTPId,
    asignaturaTPId,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP
  } = useActividadesContext();

  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/asistente/ummiaplan");
  };

 const handleSendInfo = async () => {
  if (!user || !selectedApp) return;

  const ummiappId = selectedApp.id_componente;
  const ummiappName = selectedApp.nombre;

  const { usuario, ...restoProyecto } = proyecto;
  const { roles, categories, ummiapps, ...usuarioSinCampos } = user || {};

  const proyectoActualizado = {
    ...restoProyecto,
    usuario: usuarioSinCampos,
    ummiappId,
    ummiappName,
  };

  console.log("Proyecto actualizado:", proyectoActualizado);

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  if (user.creditosDisponibles < selectedApp.valor_creditos) {
    setIsNotEnoughOpen(true);
  } else {
    enviarPropuestaInicialUsuario(proyectoActualizado, "crear_proyecto_catedra_activa");
  }
};


  const isDisabled =
    !proyecto.materias.length ||
    !proyecto.nivel_curso_cn ||
    !proyecto.tipo_estructura ||
    !isOAAdded;

  return (
    <>
      <HeaderApps
        imageSrc={UnidadTematicaCardImg}
        title="Unidad Temática"
        titleColor="#278C62"
        description="Diseña experiencias de aprendizaje innovadoras con UmmIA. Impulsa
            tus clases con metodologías activas y crea un ambiente educativo
            dinámico y participativo"
        backgroundColorImage="linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        onBack={handleBack}
        colorIconBack="#52A381"
      />
      <Grid container>
       
       
       <Grid container spacing={2}>
          <Grid item xs={12}>
            
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
       
          </Grid>
        </Grid>


        <Grid item xs={12} lg={6} sx={{mt:2}}>
          <DuracionSemanas />
        </Grid>
        <Grid item xs={12} lg={6} sx={{mt:2}}>
          <DuracionSesiones max={8} />
        </Grid>

        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          sx={{ mb: 3, mt: 5 }}
        >
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <Grid m={4}>
            <Grid item xs={12} lg={12}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12} lg={12}>
              <Caracterizacion />
            </Grid>
            <Grid item xs={12} lg={12}>
              <AdaptacionesCurriculares />
            </Grid>
          </Grid>
        )}

        <Tooltip title={isDisabled ? "Ingrese todos los campos" : ""} arrow>
          <span
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              onClick={handleSendInfo}
              disabled={isButtonDisabled}
              sx={{
                borderRadius: 5,
                m: "auto",
                width: "60%",
                alignContent: "center",
                backgroundColor: "#1FC16B",
                "&:hover": {
                  backgroundColor: "#34C759",
                },
                fontFamily: "Inter",
                fontWeight: "bold",
              }}
              data-amplify-analytics-on="click"
              data-amplify-analytics-name={`click-on-ummia-proponme-ideas`}
              data-amplify-analytics-attrs={`onClick:handleSendInfo, userId:${userId}, tipoEstructura:${tipoEstructura}, etapa:${etapa}`}
            >
              ¡UMMIA, proponme ideas geniales!
            </Button>
          </span>
        </Tooltip>
      </Grid>

      {/* Popup en caso de que se excedan créditos */}
      <NotEnoughCredits />
    </>
  );
};

export default UnidadActivaForm;
